import { safeDefine } from "../../registration/safe-define.js";
import { HotkeyElement } from "../../ui/hotkey/element.js";
//#region src/define/ui/hotkey.ts
safeDefine(HotkeyElement);
//#endregion

//# sourceMappingURL=hotkey.js.map